// extracted by mini-css-extract-plugin
export default {"recover__container":"styles_recover__container__lyiRR","recover__links":"styles_recover__links__lfC4i"};